import BrandNModel from "./brandModel.container";

export default BrandNModel;